import React, { useMemo } from 'react';

import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { StatusChip } from '../_core/_ui/status-chip.styles';
import { useCompanySportTerminology } from '../../lib/stores/company.store';
import { REPORT_CARD_STATUS_TONES } from './report-card-access.constants';
import { reportCardStatusLabels } from './report-card-access.helpers';
import { getMessages } from './report-card-access.messages';

interface IReportCardStatusChipProps {
  // Null for a staff member without a report card role on the player's age group: no chip.
  access?: IReportCardAccess | null;
}

export const ReportCardStatusChip: React.FC<IReportCardStatusChipProps> = ({ access }) => {
  const termLookup = useCompanySportTerminology();
  const labels = useMemo(() => reportCardStatusLabels(getMessages(termLookup)), [termLookup]);

  if (!access) return null;
  return (
    <StatusChip
      size="small"
      $tone={REPORT_CARD_STATUS_TONES[access.status]}
      label={<IntlMsg {...labels[access.status]} />}
    />
  );
};
